/* eslint-disable
  eslint-comments/disable-enable-pair,
  max-lines-per-function,
  react/jsx-handler-names,
  react/jsx-no-literals
*/
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import AutocompleteList from 'src/components/Autocomplete/AutocompleteList';
import AutocompleteTokens from 'src/components/Autocomplete/AutocompleteTokens';
import styles from 'src/components/Autocomplete/Autocomplete.scss';


const randomHash = new Date().getTime();
const Autocomplete = ({
  autocomplete, actions, name, placeholder
}) => {
  const { removeTag, addTag } = actions;

  const autocompleteInput = React.createRef();
  const scrollToInput = () => {
    autocompleteInput.current.focus();
  };

  const filled = autocomplete.value !== '' || autocomplete.tokens.length;
  const inputName = `${name}-${randomHash}`;

  return (
    <div
      className={ classNames({
        [styles['autocomplete-input--filled']]: filled
      }) }
      data-test="autocomplete-input"
      styleName="autocomplete-input"
    >
      <div
        data-test={ `autocomplete-${name}-input` }
        onClick={ scrollToInput }
        role="presentation"
        styleName="tokens-wrapper"
      >
        <AutocompleteTokens actions={ { removeTag } } tokens={ autocomplete.tokens } />
        <input
          ref={ autocompleteInput }
          autoComplete={ inputName }
          data-test="autocomplete-input-field"
          id={ inputName }
          onBlur={ event => actions.autocompleteBlur(event) }
          onChange={ actions.autocompleteFill }
          onFocus={ actions.autocompleteEnable }
          onKeyDown={ actions.autocompleteKeys }
          styleName="autocomplete-input__field"
          type="text"
          value={ autocomplete.value }
        />
        <label htmlFor={ inputName } styleName="autocomplete-input__placeholder">{placeholder}</label>
        <span styleName="autocomplete-input__field-bar" />
      </div>
      <input name={ name } readOnly type="hidden" value={ autocomplete.value } />
      <AutocompleteList
        actions={ { addTag } }
        list={ autocomplete.list }
        sectionName={ name }
        selected={ autocomplete.selected }
        visible={ autocomplete.show }
      />
    </div>
  );
};

Autocomplete.propTypes = {
  actions: PropTypes.shape({
    addTag: PropTypes.func,
    removeTag: PropTypes.func
  }),
  autocomplete: PropTypes.shape({
    list: PropTypes.array,
    selected: PropTypes.number,
    show: PropTypes.bool,
    tokens: PropTypes.array,
    value: PropTypes.string
  }),
  name: PropTypes.string,
  placeholder: PropTypes.string
};

Autocomplete.defaultProps = {
  actions: {},
  autocomplete: {},
  name: '',
  placeholder: ''
};

export default Autocomplete;
